import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTotalGraduatesAndStudent = async (hubIds: string[], isceD4Codes: string[], locations?: string[], fromQuarter?: string, toQuarter?: string) => {
    const { path, method } = endpoints.educationCareerPath.getTotalGraduatesAndStudent;

  let err = null;
  let res: any = null;

  try {
    ({ data: res } = await request(
        `${host}${path}`,
        method,
        { hubIds, isceD4Codes, locations, fromQuarter, toQuarter },
        {},
    ));
  } catch (error) {
    // @ts-ignore
    err = error.message;
  }

  return [err, res];
};
